var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"buttons":['cancel'],"extraLarge":"","title":"Parametrização de cota de laboratório"},on:{"save":function($event){return _vm.$refs.Form.save()}}},[_c('Form',{ref:"Form",attrs:{"data":_vm.data,"index":_vm.index,"item":_vm.item,"cotaAno":_vm.cotaAno},on:{"save":_vm.handleExit,"closeModal":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }